import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Link } from 'foundations-components/transitional/components/Link';
import { useSelector } from 'react-redux';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { getIsPublic } from '../../selectors/auth';
import { getModulesStorefrontRoute, getPublicUnifiedMarketplaceUrl, getTemplatesHomePageRoute, getThemesStorefrontRoute, getUnifiedMarketplaceUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export function UnifiedBreadcrumbs({
  linkUse,
  path,
  currentItemName,
  isPreview = false,
  onBreadcrumbClick
}) {
  const isPublic = useSelector(getIsPublic);
  const lang = getLang();
  const handleBreadcrumbClick = breadcrumbType => {
    onBreadcrumbClick === null || onBreadcrumbClick === void 0 || onBreadcrumbClick(breadcrumbType);
  };
  const marketplaceLink = /*#__PURE__*/_jsx(Link, {
    href: isPublic ? getPublicUnifiedMarketplaceUrl(lang) : getUnifiedMarketplaceUrl(),
    use: linkUse,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.breadcrumbs.marketplace"
    })
  });
  const renderBreadcrumbItems = () => {
    const templateMarketplaceLink = /*#__PURE__*/_jsx(RouterLink, {
      to: getTemplatesHomePageRoute(),
      disabled: isPreview,
      onClick: () => handleBreadcrumbClick('templates storefront home'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.breadcrumbs.templateMarketplace"
      })
    }, "template-marketplace");
    const themesLink = /*#__PURE__*/_jsx(RouterLink, {
      to: getThemesStorefrontRoute('all'),
      disabled: isPreview,
      onClick: () => handleBreadcrumbClick('themes'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.breadcrumbs.themes"
      })
    }, "themes");
    const modulesLink = /*#__PURE__*/_jsx(RouterLink, {
      to: getModulesStorefrontRoute(),
      disabled: isPreview,
      onClick: () => handleBreadcrumbClick('modules'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.breadcrumbs.modules"
      })
    }, "modules");
    const items = [];
    items.push(marketplaceLink);
    switch (path) {
      case 'templates-home':
        items.push( /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.breadcrumbs.templates"
          })
        }, "templates"));
        break;
      case 'themes-storefront':
        items.push(templateMarketplaceLink, /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.breadcrumbs.themes"
          })
        }, "themes"));
        break;
      case 'modules-storefront':
        items.push(templateMarketplaceLink, /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.breadcrumbs.modules"
          })
        }, "modules"));
        break;
      case 'theme-details':
        items.push(templateMarketplaceLink, themesLink, /*#__PURE__*/_jsx("span", {
          children: currentItemName
        }, "current"));
        break;
      case 'module-details':
        items.push(templateMarketplaceLink, modulesLink, /*#__PURE__*/_jsx("span", {
          children: currentItemName
        }, "current"));
        break;
      default:
        break;
    }
    return items;
  };
  return /*#__PURE__*/_jsx(Breadcrumbs, {
    paddingInline: "0",
    children: renderBreadcrumbItems()
  });
}